import * as React from 'react';

import { PageContainer } from 'styles/commonPageStyles';

import DividedRewards from './components/DividedRewards/DividedRewards';
import { Container } from './components/RewardsList/RewardsList.styled';
import RewardsListHeader from './components/RewardsList/RewardsListHeader';
import RewardsTableLoading from './components/RewardsList/RewardsTableLoading';
import TotalRewards from './components/TotalRewards/TotalRewards';

const RewardsPageLoading = () => (
    <PageContainer>
        <TotalRewards totalRewards={null} />
        <DividedRewards totalRewards={null} />
        <Container>
            <RewardsListHeader />
            <RewardsTableLoading />
        </Container>
    </PageContainer>
);

export default RewardsPageLoading;
